import React, { Component } from "react";
import { Link } from "react-router-dom";

export default class LinkToFaq extends Component {
    render() {
        return (
            <section className="faq-section dr-margin">
                <h3 className="header">
                    آشنایی بیشتر با دوره آنلاین MBA  
                </h3>
                <div className="content">
                    {/* <Link
                        to="/mba-program"
                        className="left-link btn btn--lg btn--primary"
                    >
                        جزئیات بیشتر
                    </Link> */}
                    <Link
                    to=""
                        className="left-link btn btn--lg btn--primary"
                    >
                        جزئیات بیشتر
                    </Link>
                    <p className="right-paragraph">
                        برای اطلاع از ویژگی‌ها و چگونگی برگزاری دوره‌، «جزئیات
                        بیشتر» را مطالعه فرمایید. پاسخ پرسش‌های پرتکرار نیز در
                        بخش «سوالات متداول» قابل دسترسی است. در صورتی که پاسخ
                        خود را در این بخش نیافتید، از طریق فرم موجود در بخش
                        «تماس با ما» پرسش خود را مطرح نمایید. کارشناسان ما در
                        اسرع وقت به پرسش شما رسیدگی خواهند کرد.
                    </p>
                </div>
                <img src="/images/registerobj.svg" alt="icon" />
            </section>
        );
    }
}
